export const VERIFICATION_STEPS_NAME = {
	step1: 'step1',
	step2: 'step2',
	step3: 'step3',
	error: 'error',
}